import { Pipe, PipeTransform } from '@angular/core';
import {Whiteboard} from '@app/state/whiteboard.state';

@Pipe({
  name: 'isSharedWith'
})
export class IsSharedWithPipe implements PipeTransform {

  public transform(whiteboard: Whiteboard, userId: number): boolean {
    return whiteboard?.sharedUsers?.has(userId) || whiteboard?.sharedUsers?.size === 0;
  }
}
